// extracted by mini-css-extract-plugin
export default {"tabheader":"TabHeader_tabheader__Ega2N"};